export default __webpack_public_path__ + "static/media/image 259.2bc00a89.png";